import { OfferingType } from '../../../Types';

export const getUtilizedOfferingTypes = (
  productLicenseOfferingTypes: ReadonlyArray<OfferingType>,
  learningDesignOfferingTypes: ReadonlyArray<OfferingType>,
): OfferingType[] =>
  productLicenseOfferingTypes.filter((offeringType) =>
    learningDesignOfferingTypes.includes(offeringType),
  );
